import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { loadJsonConfig } from '@roc-digital/mxm-base/config';
import { initHttp } from '@roc-digital/mxm-base/logic';
import { SessionState } from '@roc-digital/mxm-base/state';
import reportWebVitals from './reportWebVitals';
import { Admin } from '@/components/Admin';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { PrimeReactProvider } from 'primereact/api';

import '@roc-digital/ui-web/index.css';
import './index.css';
import './styles.css';
import "./primereact.css";

loadJsonConfig({
  env: 'qa',
  logging: false,
  mocking: false,
  cdnHost: 'https://api.qa-mxmnews.com',
  mxmApiWebUrl: process.env.REACT_APP_WEB_API_URL || '',
  mxmAuxApiUrl: process.env.REACT_APP_AUX_API_URL || '',
  mxmApiDataUrl: process.env.REACT_APP_WEB_API_URL || '',
  mxmApiAdminUrl: process.env.REACT_APP_ADMIN_API_URL || '',
  appVersion: '1.0.0',
  appDevice: 'web',
  app: undefined,
  mockingUser: '',
}).then(async () => {
  SessionState.init(sessionStorage);

  initHttp(SessionState);

  ReactDOM.render(
    <BrowserRouter>
      <DndProvider backend={HTML5Backend}>
        <PrimeReactProvider>
          <Admin />
        </PrimeReactProvider>
      </DndProvider>
    </BrowserRouter>,
    document.getElementById('root')
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
